import toSentenceCase from '../../services/toSentenceCase';
import V5_GADGET_TYPES from './V5_GADGET_TYPES';

type LegacyGadgetType = VisualisationDefinitions.GadgetType;

// Include both legacy gadget types and V5 gadget types
type GadgetItem = {
  name: LegacyGadgetType | GadgetType;
  displayName?: string;
};

const BASE_GADGETS: GadgetItem[] = [
  { name: 'SingleMetricDateMatrix', displayName: 'Single Metric Date Matrix' },
  { name: 'RankingMatrix', displayName: 'Matrix (% of total, Rank)' },
  { name: 'PaceMatrix', displayName: 'Pace Matrix' },
  { name: 'Gauge' },
  { name: 'Reminders' },
  { name: 'GroupVsRemainder', displayName: 'Group Vs Remainder' },
  { name: 'EntityInformationTable', displayName: 'Entity Information Table' },
];

// Friendly labels for V5 gadget types where toSentenceCase isn't sufficient.
const V5_GADGET_DISPLAY_NAMES: Partial<Record<GadgetType, string>> = {
  packedBubble: 'Packed Bubble',
  radar: 'Radar (Spider)',
  scatter: 'Scatter (X vs Y)',
  bubble: 'Bubble (X, Y, Size)',
  heatmap: 'Heatmap',
  funnel: 'Funnel',
  pyramid: 'Pyramid',
  sankey: 'Sankey (Flow)',
};

// Map V5 gadget types into the same structure
const V5_GADGETS: GadgetItem[] = V5_GADGET_TYPES.map((t) => ({
  name: t,
  displayName: V5_GADGET_DISPLAY_NAMES[t],
}));

const GADGETS: Array<Required<GadgetItem>> = [
  ...V5_GADGETS,
  ...BASE_GADGETS,
].map((g) => ({
  ...g,
  displayName: g.displayName ?? toSentenceCase(g.name),
}));

export default GADGETS;
